// extracted by mini-css-extract-plugin
export default {"icons":"Social_icons__QlMuI","icon":"Social_icon__EbMKg"};